/**
 * De 36 Antreja UI-iconen (brandkit v2.0, 02_Iconen/UI): 24×24-grid, lijndikte 1,7, ronde uiteinden.
 * Paden 1-op-1 uit de master-SVG's; kleur via currentColor zodat light/dark uit dezelfde bron komen.
 * Brandbook p. 29: toon bij minder bekende iconen altijd een tekstlabel; gebruik de merk-a niet als icoon.
 */
export const ICON_PATHS = {
  deur: 'M7 21V3h10v18 M7 21h12 M13 12h.01',
  slot: 'M7 10V7a5 5 0 0 1 10 0v3 M5 10h14v11H5z M12 14v3',
  open: 'M8 10V7a4 4 0 0 1 8 0 M5 10h14v11H5z M12 14v3',
  sleutel: 'M14 6a5 5 0 1 1-3 9L4 22H1v-3l7-7 M15 6h.01',
  persoon: 'M16 7a4 4 0 1 1-8 0a4 4 0 0 1 8 0 M4 21v-2a8 8 0 0 1 16 0v2',
  groep: 'M10 7a3 3 0 1 1-6 0a3 3 0 0 1 6 0 M20 7a3 3 0 1 1-6 0a3 3 0 0 1 6 0 M1 21v-3a6 6 0 0 1 12 0v3 M14 13a6 6 0 0 1 9 5v3',
  locatie: 'M19 10c0 6-7 12-7 12S5 16 5 10a7 7 0 0 1 14 0 M15 10a3 3 0 1 1-6 0a3 3 0 0 1 6 0',
  historie: 'M3 7V2 M3 7h5 M3 7a10 10 0 1 1-1 9 M12 6v6l4 3',
  melding: 'M5 17h14l-2-4V9a5 5 0 0 0-10 0v4z M10 21h4',
  batterij: 'M2 6h17v12H2z M22 10v4 M6 9v6 M10 9v6 M14 9v6',
  instellingen: 'M12 8a4 4 0 1 1 0 8a4 4 0 0 1 0-8 M12 2v3 M12 19v3 M2 12h3 M19 12h3 M5 5l2 2 M17 17l2 2 M5 19l2-2 M17 7l2-2',
  hulp: 'M21 12a9 9 0 1 1-18 0a9 9 0 0 1 18 0 M9 8a3 3 0 0 1 6 0c0 2-3 2-3 5 M12 17h.01',
  // v2.0 (4-11-2026): uitbreiding naar 36 onderwerpen (brandbook p. 65-66). Toon bij minder bekende iconen een label.
  /** Abonnement — Abonnement of pakket; geen aankoopactie op zichzelf. */
  abonnement: 'M4 4h16v16H4Z M4 9h16 M8 2v4 M16 2v4 M9 14h6 M12 11v6',
  /** Auditlog — Beheerhandelingen en controlehistorie, niet gelijk aan toegangslogboek. */
  audit: 'M4 3h11l4 4v5 M15 3v5h4 M4 3v18h7 M7 8h4 M7 12h5 M7 16h3 M19 16a4 4 0 1 1-8 0a4 4 0 0 1 8 0 M18 19l4 3',
  /** Batterij vervangen — Vervangactie; geen indicatie dat vervanging al is uitgevoerd. */
  'batterij-vervangen': 'M3 7h13v10H3Z M19 10v4 M5 3h10l-2-2 M15 3l-2 2 M14 21H4l2-2 M4 21l2 2',
  /** Cilinder — Elektronische cilinder of apparaatdetail. */
  cilinder: 'M8 4h8v8a5 5 0 1 1-8 0Z M12 7v5 M10 17h4',
  /** Beheer overdragen — Overdracht van beheer, altijd met expliciete rechten en scope. */
  delegatie: 'M8 6a3 3 0 1 1-6 0a3 3 0 0 1 6 0 M1 18v-3a4 4 0 0 1 8 0 M22 15a3 3 0 1 1-6 0a3 3 0 0 1 6 0 M15 23v-2a4 4 0 0 1 8 0 M11 6h8v4 M16 7l3 3 3-3',
  /** Deurcontact — Alleen tonen als een fysieke deurcontactfunctie beschikbaar is. */
  deurcontact: 'M4 3h10v18H4Z M10 12h.01 M18 7h3v7h-3Z M17 17l2 2 3-4',
  /** Eenmalige toegang — Eén toegangsgebruik, alleen indien ondersteund. */
  eenmalig: 'M4 3h16v18H4Z M8 7h8 M10 11l2-1v7 M10 17h4',
  /** Factuur — Facturenoverzicht of factuurdetail. */
  factuur: 'M5 2h14v20l-3-2-4 2-4-2-3 2Z M8 7h8 M8 11h8 M8 15h5',
  /** Favoriete deur — Snelkoppeling naar vaak gebruikte deur. */
  favoriet: 'm12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-3-5.6 3 1.1-6.2L3 9.6l6.2-.9Z',
  /** Firmware-update — Firmwareversie of update; combineer met voortgang en label. */
  firmware: 'M7 3v3 M12 3v3 M17 3v3 M7 18v3 M12 18v3 M17 18v3 M3 7h3 M3 12h3 M3 17h3 M18 7h3 M18 12h3 M18 17h3 M6 6h12v12H6Z M12 15V9 M9.5 11.5 12 9l2.5 2.5',
  /** Goedkeuring — Aanvraag goedkeuren; niet gebruiken als bevestigde deurstatus. */
  goedkeuren: 'M8 4H4v17h16V4h-4 M8 2h8v5H8Z M8 13l3 3 5-6',
  /** Terugkerend schema — Wekelijks of periodiek toegangsrooster. */
  herhalen: 'M4 9V5h14l-3-3 M18 5l-3 3 M20 15v4H6l3 3 M6 19l3-3 M8 12h8',
  /** Apparaat koppelen — Apparaat of account koppelen; geen bereikbaarheidsgarantie. */
  koppelen: 'M10 8l2-2a4 4 0 0 1 6 6l-2 2 M14 16l-2 2a4 4 0 0 1-6-6l2-2 M8 16l8-8',
  /** Inrichten — Stappenplan voor eerste inrichting. */
  onboarding: 'M3 6l2 2 3-4 M11 6h10 M3 13l2 2 3-4 M11 13h10 M4 20h3 M11 20h10',
  /** Onderhoud — Onderhoudstaak of serviceactie. */
  onderhoud: 'M14 4a6 6 0 0 0-7 7L2 16a3 3 0 0 0 4 4l5-5a6 6 0 0 0 7-7l-4 4-3-3Z',
  /** Ontkoppelen — Bestaande koppeling verwijderen met bevestiging. */
  ontkoppelen: 'M9 9 6 12a4 4 0 0 0 6 6l2-2 M15 15l3-3a4 4 0 0 0-6-6l-2 2 M3 3l18 18',
  /** Privacy — Privacyinstellingen of informatie; geen certificeringsclaim. */
  privacy: 'M12 2 3 6v6c0 5 9 10 9 10s9-5 9-10V6Z M9 11V9a3 3 0 0 1 6 0v2 M8 11h8v6H8Z',
  /** QR scannen — QR-code scannen voor koppeling of identificatie. */
  'qr-scan': 'M3 8V3h5 M16 3h5v5 M21 16v5h-5 M8 21H3v-5 M7 7h3v3H7Z M14 7h3v3h-3Z M7 14h3v3H7Z M14 14h3v3 M14 17h.01',
  /** Serienummer — Apparaatidentificatie, geen scanactie. */
  serienummer: 'M3 5h18v14H3Z M6 8v6 M9 8v6 M11 8v6 M14 8v6 M17 8v6 M6 16h5',
  /** Ondersteuning — Contact met ondersteuning; geen 24/7-beschikbaarheidsclaim. */
  support: 'M4 13v-2a8 8 0 0 1 16 0v6a4 4 0 0 1-4 4h-3 M2 11h4v7H2Z M18 11h4v7h-4Z M10 20h4v2h-4Z',
  /** Telefoon — Telefoon als apparaat of toegangsmiddel. */
  telefoon: 'M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z M9 5h6 M11 19h2',
  /** Supportverzoek — Individueel supportticket met eigen status. */
  ticket: 'M3 5h18v5a2 2 0 0 0 0 4v5H3v-5a2 2 0 0 0 0-4Z M15 8v2 M15 12v2 M15 16h.01',
  /** Toegang intrekken — Intrekken van rechten; toon apart of de wijziging is verwerkt. */
  'toegang-intrekken': 'M10 7a4 4 0 1 1-8 0a4 4 0 0 1 8 0 M2 21v-2a6 6 0 0 1 10-4 M15 8h7 M17 15l5 6 M22 15l-5 6',
  /** Uitzonderingsdag — Afwijkende dag, bijvoorbeeld feestdag of sluiting. */
  uitzondering: 'M3 5h18v16H3Z M7 2v6 M17 2v6 M3 10h18 M10 13l4 5 M14 13l-4 5',
} as const;

export type IconName = keyof typeof ICON_PATHS;

/** Lijndikte uit het brandbook; gelijk houden binnen één interface. */
export const ICON_STROKE = 1.7;
